import { TestContext } from 'yup'

export interface TestContextExtended {
  options: {
    index: number,
  }
}

export function isUniqueObjectPropertyInArray(
  value: string | undefined,
  context: TestContext,
  arrayProperty: string,
  propertyName: string,
  depth = 1,
): boolean {
  if (!value) {
    return true
  }

  const extendedContext = context as TestContext & TestContextExtended
  const currentIndex = extendedContext.options.index
  const array = context?.from?.[depth].value?.[arrayProperty]
  const firstIdx = array.findIndex(
    (
      item: { [propertyName: string]: string },
    ) => item[propertyName].toLowerCase().trim() === array[currentIndex][propertyName].toLowerCase().trim(),
  )

  return array[currentIndex] === array[firstIdx]
}
